import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

/**
 * AuthCallback
 *
 * El backend redirige aquí después de validar al usuario con Microsoft Entra ID.
 * Los datos de display llegan como query params (no sensibles — el JWT va en cookie HttpOnly).
 * Esta página replica la lógica de saveDataLocal + redirAfterLogin del Login normal.
 */
const AuthCallback = () => {
  const history = useHistory();

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);

      const message = params.get("message");
      const UID = params.get("UID");
      const OID = params.get("OID");
      const nombreUser = params.get("nombreUser");
      const nombreOrganizacion = params.get("nombreOrganizacion");
      const rol = params.get("rol");
      const idioma = params.get("idioma");

      // Si no llegan los datos mínimos, redirigir al login con indicador de error
      if (!message || !UID) {
        history.replace("/?entra_error=callback_invalid");
        return;
      }

      // Guardar en localStorage — misma estructura que saveDataLocal en Login.jsx
      localStorage.setItem("tokenuserid", message);
      localStorage.setItem("cm9sX3VzdWFyaW8=", rol || "");
      localStorage.setItem("nombreUser", nombreUser || "");
      localStorage.setItem("nombreOrganizacion", nombreOrganizacion || "");
      localStorage.setItem("OID", OID || "");
      localStorage.setItem("UID", UID || "");
      localStorage.setItem("rol", rol || "");
      localStorage.setItem("loginMethod", "entra");

      // Preservar idioma seleccionado antes del flujo Entra (o usar el de BD)
      const idiomaActual = localStorage.getItem("idiomaLogin");
      if (!idiomaActual && idioma) {
        localStorage.setItem("idioma", idioma);
      }

      // Limpiar params sensibles de la URL antes de redirigir
      window.history.replaceState({}, document.title, window.location.pathname);

      // Redirigir según rol (misma lógica que redirAfterLogin)
      const rolNum = Number(rol);
      if (rolNum === 81) {
        history.replace("/tasks");
      } else {
        history.replace("/landing");
      }
    } catch (err) {
      console.error("Error en AuthCallback:", err);
      history.replace("/");
    }
  }, [history]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "sans-serif",
        gap: "12px",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "4px solid #e0e0e0",
          borderTop: "4px solid #0078d4",
          borderRadius: "50%",
          animation: "spin 0.8s linear infinite",
        }}
      />
      <p style={{ color: "#555", margin: 0 }}>
        Completando autenticación con Microsoft...
      </p>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

export default AuthCallback;
